<h1 mat-dialog-title>
  {{ (data.useExistingProtocol || data.idProtocol != null ? 'protocolEdit.dialog.executionData.title' :
  'executionEdit.dialog.executionData.title') | translate }}
</h1>

<div mat-dialog-content class="thermal-theme">

  <div fxLayout="row" class="flexwrap">
    <div fxFlex="40">
      @if (!data.useExistingProtocol) {
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.protocol.client.label' | translate }}</mat-label>
          <mat-select #clientSelect name="idClient" [(ngModel)]="data.idClient">
            @if (clientSelect.focused) {
              <mat-select-filter [displayMember]="'name'" [array]="clients"
                (filteredReturn)="clientsFiltered =$event" [noResultsMessage]="'common.noResults' | translate"
                [placeholder]="'common.selectFilterPlaceholder' | translate">
              </mat-select-filter>
            }
            @for (client of clientsFiltered; track client) {
              <mat-option [value]="client.id">
                {{client.name}}
              </mat-option>
            }
          </mat-select>
          <mat-error>
            {{ 'executionEdit.protocol.client.error' | translate }}
          </mat-error>
        </mat-form-field>
      }

      @if (data?.useExistingProtocol) {
        <div>
          <mat-label>{{ 'executionEdit.protocol.client.label' | translate }}</mat-label>
          <mat-select name="idClientProtocol" [(ngModel)]="data.idClientProtocol">
            @for (item of clients; track item) {
              <mat-option [value]="item.id">
                {{item.name}} ({{item.address}})
              </mat-option>
            }
          </mat-select>
        </div>
      }
    </div>
    <div fxFlex="30">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.documentCode.documentCode.label' | translate }}</mat-label>
        <input matInput name="documentCode" [(ngModel)]="data.projectNo" required>
        <mat-error>
          {{ 'protocolEdit.dialog.documentCode.documentCode.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    @if (!data.useExistingProtocol && data?.idProtocol == null) {
      <div fxFlex="30">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.general.projectManager.label' | translate }}</mat-label>
          <mat-select name="projectManager" [(ngModel)]="data.usernameProjectManager">
            <mat-option>--</mat-option>
            @for (item of respField; track item) {
              <mat-option [value]="item.username">
                {{ item.fullName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
</div>

<div mat-dialog-actions align="end" class="getTheme()">
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>